import { Injectable } from '@angular/core';
import { VentaService } from 'src/app/modules/venta';
import { MotivosService } from 'src/app/modules/venta/services/motivos.service';

@Injectable({
  providedIn: 'root'
})
export class MotivoPadService {

  order = '';
  selected;
  motivo;
  constructor(private motivoService: MotivosService) {}

  setNumpadOrder(order: string) {
    if (!this.selected) {
      return;
    }
    
    if (!this.motivo) {
      return;
    }
    
    this.order = order;
    const nuevoValor = this.orderDispatcher();
    this.selected.value = nuevoValor;
  }

  orderDispatcher(): string {
    if (!this.selected) {
      return '';
    }
    
    switch (this.order) {
      case 'delete':
        const valorActual = this.selected.value || '';
        const newstr = valorActual.substring(0, valorActual.length - 1);
        if (newstr.length > 0) {
          this.motivoService.pushMotivo(this.motivo, +newstr);
          return newstr;
        } else {
          this.motivoService.pushMotivo(this.motivo, 0);
          // Limpiar también el input oculto si existe
          if (this.motivo && this.motivo.PkId) {
            const inputOculto = document.getElementById(`motivo-${this.motivo.PkId}`) as HTMLInputElement;
            if (inputOculto) {
              inputOculto.value = '';
            }
          }
          // Limpiar el input actual también
          if (this.selected) {
            this.selected.value = '';
          }
          return '';
        }
      case 'reset':
        this.motivoService.pushMotivo(this.motivo, 0);
        return '0';
      case 'losefocus':
        if (this.selected.value === '') {
          this.selected.value = 0;
          this.motivoService.pushMotivo(this.motivo, 0);
        }
        this.selected.focus = false;
        return this.selected.value;
      default:
        // Verificar si el motivo ya tiene una cantidad en el servicio
        const motivoExistente = this.motivoService.motivosSeleccionadosValue
          ?.find(m => m.idEntrada === this.motivo.idEntradaAsociada)
          ?.lista?.find(m => m.PkId === this.motivo.PkId);
        
        // Si existe en el servicio, usar ese valor como base (es la fuente de verdad)
        // Si no existe, usar el valor del input, pero si el input tiene un valor antiguo incorrecto,
        // preferir vacío para empezar de cero
        let oldValue = '';
        if (motivoExistente && motivoExistente.numMotivo) {
          oldValue = String(motivoExistente.numMotivo);
        } else {
          // Si no existe en el servicio, usar el valor del input solo si es válido
          const inputValue = this.selected.value || '';
          // Si el input tiene un valor pero el motivo no existe en el servicio, limpiar
          // (puede ser un valor residual de un input oculto)
          if (inputValue && !motivoExistente) {
            // Limpiar el input oculto si existe
            if (this.motivo && this.motivo.PkId) {
              const inputOculto = document.getElementById(`motivo-${this.motivo.PkId}`) as HTMLInputElement;
              if (inputOculto && inputOculto.value) {
                inputOculto.value = '';
              }
            }
            oldValue = '';
          } else {
            oldValue = inputValue;
          }
        }
        
        // Si oldValue es '0', tratarlo como vacío para empezar de cero
        const baseValue = (oldValue === '0' || oldValue === '') ? '' : oldValue;
        
        if (baseValue === '' && this.order === '0') {
          return '';
        }
        const newValue = baseValue.concat(this.order);
        const Ncomma = (newValue.match(/,/g) || []).length;
        let Nintegers = 0;
        let Ndecimals = 0;
        if (Ncomma > 0) {
          Nintegers = newValue.split('.')[0].length;
          Ndecimals = newValue.split('.')[1].length;
        } else {
          Nintegers = newValue.length;
        }
        
        if (Ncomma < 2) {
          if (Ndecimals < 3 && Nintegers < 4) {
            if (baseValue === '' || baseValue === '0') {
              this.motivoService.pushMotivo(this.motivo, +this.order);
              return this.order;
            } else {
              this.motivoService.pushMotivo(this.motivo, +newValue);
              return newValue;
            }
          } else {
            return baseValue;
          }
        } else {
          return baseValue;
        }
    }
  }

}
